import * as React from 'react';
import { useEffect, useState } from 'react';
import wrapStore from '@src/utils/wrap-store';

import styles from './index.less';
import aos from '@src/utils/aos';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';
import SupplierStore from './store';
import SupplierCompon from './Comts';
// import SilentVideo from '@src/components/silent-video';
const SupplierPage = ({ store }) => {
  store.use();
  aos.reInit();

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!isVisible) {
            setIsVisible(true);
            observer.disconnect(); // 一旦显示就停止观察
          }
        }
      },
      {
        threshold: 0.6 // 当10%的元素可见时触发
      }
    );

    const element = document.getElementById('supplier');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className={cx(styles.root, 'section', { [styles.visibleRoot]: isVisible })} id="supplier">
      <div className={styles.box}>
        <div className={styles.rightA} />
        <div className={styles.title}>西山居优秀供应商</div>
        <SupplierCompon />
        <div className={styles.introContBox}>
          <BaseSwiper store={store.introSwiper}>
            {store.companyList.map((item, index) => (
              <div key={index} className={styles.item}>
                <div className={styles.roleCont}>
                  <div className={styles.roleIcon}>
                    <img src={item.photo} />
                  </div>
                  <div className={styles.nameCon}>
                    <div className={styles.name}>{item.name}</div>
                    <div className={styles.role}>{item.role}</div>
                  </div>
                </div>
                <div className={styles.line} />
                <div className={styles.introCont}>
                  <div className={styles.icon}>
                    <img src={item.logo} />
                  </div>
                  <div className={styles.content}>{item.detail}</div>
                </div>
              </div>
            ))}
          </BaseSwiper>
        </div>
      </div>
      <div className={styles.indexs}>
        {!!store.indexList.length &&
          store.indexList.map((item, index) => (
            <div
              key={index}
              className={cx({
                [styles.indexDef]: true,
                [styles.indexActive]: store.indexsActive === index + 1
              })}
              onClick={() => store.goSlide(index)}
            />
          ))}
      </div>
    </div>
  );
};

export default wrapStore(SupplierPage, SupplierStore);
